const AUTH0 = {
  appBasePath: process.env.REACT_APP_BASE_PATH,
  storageBasePath: process.env.REACT_APP_STORAGE_PATH,
  serverBasePath: process.env.REACT_APP_SERVER_BASE_PATH,
  oidcUrl: process.env.REACT_APP_OIDC_URL
};
export default AUTH0;
